<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">
                    {{ $t('interventionreport.titleTable') }}
                </h2>
            </div>
            <div class="card">
                <div class="card__detail">

                    <div class="" v-if="items">
                        <div class="nodata" v-if="items.data && items.data.length == 0">
                            {{ $t('common.nodata') }}
                        </div>
                        <div class="list__box">
                            <div class="list__item" v-for="item in (items.data)" v-bind:key="item.id">
                                <span class="col">
                                    <strong>{{ item.customer.agency }}</strong>
                                    {{ item.customer.address }}
                                </span>
                                <span class="col">
                                    {{ item.datainizio | formatDate }} -
                                    {{ item.datafine | formatDate }}
                                </span>

                                <span class="col">
                                    <button class="btn" type="button" @click="preview(item)" :disabled="loading">
                                        <span>{{ $t('common.preview') }}</span>
                                    </button>
                                    <!--<button class="btn light" type="button" @click="downloadPdf(item)" :disabled="loading">
                                        <span v-if="loading">{{ $t('common.loading') }}</span>
                                        <span v-if="!loading">{{ $t('common.download') }}</span>
                                    </button>-->
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- paginazione -->
                    <div class="pagination" v-if="items && items.pages">
                        <button class="btn-page" :disabled="page == 1" @click="firstPage()"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i></button>
                        <button class="btn-page" :disabled="page == 1" @click="prevPage()"><i class="fa fa-chevron-left"></i></button>
                        <button class="btn-page" v-bind:class="{'current-page': p == page}" v-for="p in buildPageArray(7)" @click="goPage(p)" v-bind:key="p">
                            {{p}}
                        </button>
                        <button class="btn-page" :disabled="page == items.pages" @click="nextPage()"><i class="fa fa-chevron-right"></i></button>
                        <button class="btn-page" :disabled="page == items.pages" @click="lastPage()"><i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i></button>
                    </div>


                </div>
            </div>
        </div>
        <anteprima-modal :wid="true" v-model="showPreview" :item="dataPreview" :structure="intervention_reports.structureDoc"></anteprima-modal>
    </main>
</template>
<script>
    import Pagination from "../../components/Pagination";
    import AnteprimaModal from "../../components/AnteprimaModal";

    export default {
        name: 'interventionreports-offline',
        components: {
            AnteprimaModal,
        },
        mounted() {
            this.updateData();
        },
        data() {
            return {
                'intervention_reports': this.api.intervention_reports,
                'isFiltered': false,
                'searchText': null,
                'p': this.pdf,
                'loading': false,
                'showPreview': false,
                'dataPreview': null,
                'page': 1,
                'pageSize': 8,
                'items': []
            }
        },
        methods: {
            updateData() {
                this.loading = true;
                this.api.intervention_reports.offline.get(this.page, this.pageSize, this.searchText)
                    .then((data) => {
                        this.items = data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            nextPage() {
                if (this.page < this.items.pages) {
                    this.page += 1;
                    this.updateData();
                }
            },
            prevPage() {
                if (this.page > 1) {
                    this.page -= 1;
                    this.updateData();
                }
            },
            firstPage() {
                this.page = 1;
                this.updateData();
            },
            lastPage() {
                this.page = this.items.pages || 1
                this.updateData();
            },
            goPage(page) {
                this.page = page;
                this.updateData();
            },
            buildPageArray(num) {
                let start = 1;
                if (this.items.page > Math.round(num / 2)) {
                    start = this.items.page - Math.floor(num / 2);
                }
                let end = this.items.pages;
                if (this.items.page < (this.items.pages - Math.floor(num / 2))) {
                    end = this.items.page + Math.floor(num / 2);
                }
                let result = [];
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
                return result;
            },
            downloadPdf(item) {
                this.loading = true;
                this.p.buildPdf(this.api.intervention_reports.structureDoc, item, (status) => {
                    if(status == 'end') {
                        this.loading = false;
                    }
                });
            },
            preview(item) {
                let obj = {...item};
                obj.products = JSON.parse(obj.products);
                this.dataPreview = obj;
                this.showPreview = !this.showPreview;
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    .card {
        &__header {
            display: flex;
            justify-content: space-between;
            background: transparent;
            height: auto;
            padding: 0 0 15px 0;
            .card__header-link {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: $middle-green;
                padding: 10px 20px;
                transition: 300ms $ease-out-quint;
                .btn {
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }
                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;
                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%,-50%);
                            &:last-of-type {
                                transform: translate(-50%,-50%) rotate(90deg);
                            }
                        }
                    }
                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                }
                &:hover {
                    background: $white;
                    .btn {
                        &-icon .bar { background: $middle-green; }
                        &-label { color: $middle-green; }
                    }
                }
            }
        }
    }
    .customers__list {
        display: flex;
        flex-direction: column;
        .customer {
            padding: 15px 10px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: $middle-green;
                width: 100%;
                height: 100%;
                z-index: 1;
                transform: scaleY(0);
                transform-origin: center bottom;
                transition: 600ms $ease-out-quint;
            }
            &__agency,
            &__referent {
                position: relative;
                z-index: 2;
                transition: 600ms $ease-out-quint;
            }
            &__agency {
                display: block;
                width: 100%;
                font-size: 1.5em;
                font-weight: 300;
                padding-bottom: 7px;
            }
            &__referent {
                font-size: 0.7em;
                text-transform: uppercase;
                color: $gray;
                strong {
                    font-weight: 700;
                }
            }
            &:nth-of-type(even) {
                background: rgba($gray, 0.05);
            }
            &:hover {
                .customer__agency,
                .customer__referent {
                    color: $white;
                }
                &:before {
                    transform: scaleY(1);
                    transform-origin: center top;
                }
            }
        }
    }
</style>
